import { All, KeyValue } from "../interfaces";
import { connect } from "react-redux";
import * as actions from "../common/actions";
import { Dispatch } from "react";
import GrowthRate from "../components/SOD/MarketShare/GrowthRate/GrowthRate";

export function mapStateToProps({ appState }: All) {
  return {
    appState: (appState as KeyValue)[appState.app],
  };
}
function mapDispatchToProps(dispatch: Dispatch<actions.AllActions>) {
  return {
    updateFilter: (field: string, value: string | number) => {
      dispatch(actions.updateFilter(field, value));
      dispatch(actions.searchPush());
    },
    updateSearch: (field: string, value: string) => {
      dispatch(actions.updateSearch(field, value));
      dispatch(actions.searchPush());
    },
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(GrowthRate);
